import { Link } from 'react-router-dom'
import { User, Code, Shield, Store, Github, Heart } from 'lucide-react'
import { useAuthStore } from '../stores/authStore'

export default function DashboardFooter() {
  const { user } = useAuthStore()

  return (
    <footer 
      className="border-t mt-auto py-6 px-6"
      style={{ 
        backgroundColor: 'var(--color-bg-secondary)',
        borderColor: 'var(--color-border)'
      }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-3" style={{ color: 'var(--color-text-primary)' }}>
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/profile"
                  className="flex items-center gap-2 text-sm transition hover:opacity-70"
                  style={{ color: 'var(--color-text-secondary)' }}
                >
                  <User size={14} />
                  Profile & Settings
                </Link>
              </li>
              <li>
                <Link
                  to="/app-store"
                  className="flex items-center gap-2 text-sm transition hover:opacity-70"
                  style={{ color: 'var(--color-text-secondary)' }}
                >
                  <Store size={14} />
                  App Store
                </Link>
              </li>
            </ul>
          </div>

          {/* Developer & Admin Links */}
          <div>
            <h4 className="font-semibold mb-3" style={{ color: 'var(--color-text-primary)' }}>
              Advanced
            </h4>
            <ul className="space-y-2">
              {user?.role === 'developer' && (
                <li>
                  <Link
                    to="/developer"
                    className="flex items-center gap-2 text-sm transition hover:opacity-70"
                    style={{ color: 'var(--color-text-secondary)' }}
                  >
                    <Code size={14} />
                    Developer Portal
                  </Link>
                </li>
              )}
              {user?.role === 'admin' && (
                <li>
                  <Link
                    to="/admin"
                    className="flex items-center gap-2 text-sm transition hover:opacity-70"
                    style={{ color: 'var(--color-text-secondary)' }}
                  >
                    <Shield size={14} />
                    Admin Panel
                  </Link>
                </li>
              )}
              {!user?.role || (user?.role !== 'developer' && user?.role !== 'admin') ? (
                <li>
                  <Link
                    to="/apply-developer"
                    className="flex items-center gap-2 text-sm transition hover:opacity-70"
                    style={{ color: 'var(--color-text-secondary)' }}
                  >
                    <Code size={14} />
                    Apply for Developer Access
                  </Link>
                </li>
              ) : null}
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="font-semibold mb-3" style={{ color: 'var(--color-text-primary)' }}>
              About
            </h4>
            <p className="text-sm mb-3" style={{ color: 'var(--color-text-secondary)' }}>
              Dashit.io - Your personal command center
            </p>
            <div className="flex gap-3">
             
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div 
          className="pt-6 border-t text-center text-sm flex items-center justify-center gap-1"
          style={{ 
            borderColor: 'var(--color-border)',
            color: 'var(--color-text-secondary)'
          }}
        >
          Made with <Heart size={14} className="text-red-500 fill-red-500" /> by the Dashit.io Team © {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  )
}

